import { deviceSchema } from './device.schema';
import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const deviceSnapshotSchema = z.object({
  startDate: coercedDate,
  endDate: coercedDate,
  pendingDevicesTotalCount: z.number(),
  devices: z.array(deviceSchema),
});

export type DeviceSnapshot = z.infer<typeof deviceSnapshotSchema>;
